// @ts-check
import * as Contentstack from 'contentstack';
import ContentstackLivePreview from '@contentstack/live-preview-utils';
import config from '~/config';

/** @type {import('contentstack').Config} */
const stackConfig = {
	api_key: config.ContentStackApiKey,
	delivery_token: config.ContentStackDeliveryToken,
	environment: config.ContentStackEnvironment,
	live_preview: {
		enable: true,
		host: config.ContentStackPreviewHost,
		preview_token: config.ContentStackPreviewToken,
	},
};

const innerStack = Contentstack.Stack(stackConfig);
if (config.ContentStackApiHost) {
	innerStack.setHost(config.ContentStackApiHost);
}

// Export needed variables
export { addEditableTags } from '@contentstack/utils';
export const Stack = innerStack;
export const IsLivePreviewEnabled = config.ContentStackLivePreview === 'true';
export const onEntryChange = ContentstackLivePreview.onEntryChange;
export const unsubscribe = ContentstackLivePreview.unsubscribeOnEntryChange;

// Init the LP library if needed (adds edit tags, registers hooks, etc)
if (IsLivePreviewEnabled) {
	ContentstackLivePreview.init({
		enable: true,
		// @ts-ignore
		stackSdk: innerStack,
		ssr: false,

		editButton: {
			enable: true,
			exclude: ['outsideLivePreviewPortal'],
		},
	});
}

